// Копейки -> сумма в единицах валюты с разделением разрядов: 1234567 -> "12 345.67"
export default function(amountKopecks: number | string | bigint | null | undefined): string {
    if (amountKopecks === null || amountKopecks === undefined) {
        return '-';
    }
    if (typeof amountKopecks === 'number') {
        amountKopecks = Math.round(amountKopecks);
    }

    const bigIntAmountKopecks = BigInt(amountKopecks);
    const sign = bigIntAmountKopecks < BigInt(0) ? '-' : '';
    const absAmountKopecks = sign ? -bigIntAmountKopecks : bigIntAmountKopecks;
    const int = absAmountKopecks / BigInt(100);
    const frac = absAmountKopecks % BigInt(100);
    const formattedInt = `${int}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${sign}${formattedInt}.${frac < BigInt(10) ? '0' : ''}${frac}`;
}
